import { ReactNode } from 'react';

import styles from './dialogFooter.module.css';

export type DialogFooterProps = {
	children?: ReactNode;
};

export const DialogFooter = ({ children }: DialogFooterProps) => (
	<div className={styles.root}>
		<footer className={styles.footer}>{children}</footer>
	</div>
);
